<template>
    <vTransactionAttachmentComponent :postList="postList" v-if="flag"></vTransactionAttachmentComponent>
</template>
<script>
import vTransactionAttachmentComponent from '../../listComponent/basicdata/transactionAttachment/transactionAttachmentComponent.vue';
export default {
    name: 'transactionAttachmentList',
    components: {
        vTransactionAttachmentComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>